import { PiecesUom, DimsUom, WeightsUom, VolumesUom } from '../units-of-measure';
export { PiecesUom, DimsUom, WeightsUom, VolumesUom };

export interface Calculator {
   pieces: number;
   weight: number;

   length?: number;
   width?: number;
   height?: number;

   description?: string;
   reference?: string;

   weight_type: WeightsUom;
   measure_type: DimsUom;
}

export class Calculator implements Calculator {
   constructor( c?: any ) {
      this.pieces = c?.pieces;
      this.weight = c?.weight;

      if ( c?.length ) { this.length = c?.length; }
      if ( c?.width ) { this.width = c?.width; }
      if ( c?.height ) { this.height = c?.height; }

      if ( c?.description ) { this.description = c?.description; }
      if ( c?.reference ) { this.reference = c?.reference; }

      this.weight_type = c?.weight_type;
      this.measure_type = c?.measure_type;
   }
}

export function isBlankCalculator( c: Calculator ): boolean {
   const item = { ...c };

   delete( item.weight_type );
   delete( item.measure_type );

   return !Object.values( item ).filter( v => !!v ).length;
}

export function CalculatorArray( array?: any[] ): Calculator[] {
   return ( array?.map( c => new Calculator( c )) || [] )
      .filter( c => !isBlankCalculator( c ));
}

import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
export function calcGroup( c?: any ): FormGroup {
   return new FormGroup({
      pieces: new FormControl( c?.pieces, [ Validators.min( 1 ) ]),
      weight: new FormControl( c?.weight, [ Validators.min( 1 ) ]),

      length: new FormControl( c?.length, [ Validators.min( 0 ) ]),
      width:  new FormControl( c?.width,  [ Validators.min( 0 ) ]),
      height: new FormControl( c?.height, [ Validators.min( 0 ) ]),

      description:  new FormControl( c?.description, [ Validators.maxLength( 35 ) ]),
      reference:  new FormControl( c?.reference, [ Validators.maxLength( 35 ) ]),

      weight_type:  new FormControl( c?.weight_type ?? WeightsUom[0] ),
      measure_type: new FormControl( c?.measure_type ?? DimsUom[0] ),
   });
}

export function calcArray( calculator: Calculator[] = [] ): FormArray {
   const calc = new FormArray( [] );

   calculator.map( c => new Calculator( c )).filter( c => !isBlankCalculator( c ))
      .map( c => calc.push( setCalcGroupValidators( calcGroup( c ))));

   return calc;
}

export function setCalcGroupValidators( g: FormGroup ): FormGroup {
   g.get( 'pieces' ).addValidators( Validators.required );
   g.get('pieces').updateValueAndValidity({ onlySelf: true });

   g.get( 'weight' ).addValidators( Validators.required );
   g.get('weight').updateValueAndValidity({ onlySelf: true });

   return g;
}
